<template>
    <div id="spinnerContainer">
        <transition appear name="appear">
            <div class="lds-spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </transition>
    </div>
</template>

<script>
import Menu from "@/components/Menu";
import { store } from "@/centralStore";
export default {
    name: "NewSplashPage",
    components: {
        Menu
    },
    data() {
        return {
            store: store.state
        };
    },
    mounted() {
        var myself = this;
        myself.store.splashPage = true;
        setTimeout(function() {
            // console.log("splash", myself.store.afterSplashId);
            // console.log("splash", myself.store.afterSplashSlug);
            myself.store.splashPage = false;
            myself.store.splashAllowed = false;
            myself.$router.push({
                name: myself.store.afterSplashName,
                params: {
                    id: myself.store.afterSplashId,
                    slug: myself.store.afterSplashSlug
                }
            });
        }, 2500);
    }
};
</script>

<style scoped>
@keyframes fontani {
    10% {
        font-variation-settings: "wght" 76, "hght" 536, "prtn" 1000;
    }
    50% {
        font-variation-settings: "wght" 76, "hght" 536, "prtn" 0;
    }
    100% {
        font-variation-settings: "wght" 76, "hght" 536, "prtn" 952;
    }
}
/* div { */
/*     color: white; */
/*     font-size: 2.3rem; */
/*     line-height: 6rem; */
/*     background-color: black; */
/*     width: 100vw; */
/*     display: flex; */
/*     justify-content: center; */
/*     align-items: center; */
/*     height: calc(100vh - 9rem); */
/*     height: calc(100dvh - 9rem); */
/* } */
/* @media screen and (min-width: 768px) { */
/*     div { */
/*         font-size: 4rem; */
/*     } */
/* } */
p {
    text-align: center;
    font-family: "JMMP Display";
    font-feature-settings: "ss01" on;
    /*animation: fontani 5s infinite;*/
}
.lds-spinner {
    color: official;
    display: inline-block;
    position: absolute;
    width: 80px;
    height: 80px;
    left: calc(50% - 40px);
    top: calc(50% - 40px);
    transform: scale(0.5);
}

.lds-spinner div {
    transform-origin: 40px 40px;
    animation: lds-spinner 1.2s linear infinite;
}

.lds-spinner div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 3px;
    left: 37px;
    width: 6px;
    height: 18px;
    border-radius: 20%;
    background: #fff;
}

.lds-spinner div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
}

.lds-spinner div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
}

.lds-spinner div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
}

.lds-spinner div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
}

.lds-spinner div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
}

.lds-spinner div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
}

.lds-spinner div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
}

.lds-spinner div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
}

.lds-spinner div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
}

.lds-spinner div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
}

.lds-spinner div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
}

.lds-spinner div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
}

@keyframes lds-spinner {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}
.appear-enter-active,
.appear-leave-active {
    transition: opacity 0.5s;
}

.appear-enter,
.appear-leave-to

/* .fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
}
</style>
